function LabelMultiple() {
  return (
    <blockquote className="p-4 bg-white">
      <h4 className="h6 mb-3">What It Means</h4>
      <p>A form control has more than one label associated with it.</p>
      <h4 className="h6 mb-3">Why It Matters</h4>
      <p>A form control should have at most one associated label element. If more than one label element is associated to the control, assistive technology may not read the appropriate label.</p>
      <h4 className="h6 mb-3">What To Do</h4>
      <p>Ensure that at most one label element is associated to the form control. If multiple form labels are necessary, use aria-labelledby.</p>
    </blockquote>
  )
}

export default LabelMultiple